import React, { useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { formatBRL } from '../utils/currency';
import '../styles/Cart.css';

const MobileCartBar: React.FC = () => {
  const { totalQty, subtotalCents, openCart } = useCart();
  const visible = totalQty > 0;

  useEffect(() => {
    if (visible) {
      document.body.classList.add('has-mini-cart');
      return () => document.body.classList.remove('has-mini-cart');
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="mobile-cart-bar" role="region" aria-label="Resumo do carrinho">
      <div className="mobile-cart-bar-content">
        <div className="subtotal">
          <span>Subtotal</span>
          <strong>{formatBRL(subtotalCents)}</strong>
        </div>
        <button className="btn btn-success" onClick={openCart}>Ver Carrinho</button>
      </div>
    </div>
  );
};

export default MobileCartBar;

